import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SubscriptionProvider } from "@/context/SubscriptionContext";
import { Gate } from "@/components/Gate";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import StockDetail from "@/pages/StockDetail";
import Scanner from "@/pages/Scanner";
import Stocks from "@/pages/Stocks";
import Crypto from "@/pages/Crypto";
import Forex from "@/pages/Forex";
import Ideas from "@/pages/Ideas";
import Backtest from "@/pages/Backtest";
import AutoTrader from "@/pages/AutoTrader";
import AutoTraderFx from "@/pages/AutoTraderFx";
import Scorecard from "@/pages/Scorecard";
import Trading from "@/pages/Trading";
import Assistant from "@/pages/Assistant";
import Alerts from "@/pages/Alerts";
import Install from "@/pages/Install";
import Pricing from "@/pages/Pricing";
import Account from "@/pages/Account";
import Invite from "@/pages/Invite";
import Guide from "@/pages/Guide";
import Policy from "@/pages/Policy";
import Status from "@/pages/Status";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import { Loader } from "@/components/widgets";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="h-screen bg-background"><Loader label="Authenticating" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return <SubscriptionProvider><Layout>{children}</Layout></SubscriptionProvider>;
}

function LoginRoute() {
  const { user, ready } = useAuth();
  if (!ready) return <div className="h-screen bg-background" />;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/privacy" element={<Policy doc="privacy" />} />
            <Route path="/terms" element={<Policy doc="terms" />} />
            <Route path="/risk" element={<Policy doc="risk" />} />
            <Route path="/status" element={<Status />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/scanner" element={<Protected><Gate need="pro"><Scanner /></Gate></Protected>} />
            <Route path="/stocks" element={<Protected><Stocks /></Protected>} />
            <Route path="/crypto" element={<Protected><Crypto /></Protected>} />
            <Route path="/forex" element={<Protected><Gate need="pro"><Forex /></Gate></Protected>} />
            <Route path="/ideas" element={<Protected><Gate need="elite"><Ideas /></Gate></Protected>} />
            <Route path="/backtest" element={<Protected><Gate need="elite"><Backtest /></Gate></Protected>} />
            <Route path="/auto" element={<Protected><Gate need="elite"><AutoTrader /></Gate></Protected>} />
      <Route path="/auto-fx" element={<Protected><Gate need="elite"><AutoTraderFx /></Gate></Protected>} />
            <Route path="/scorecard" element={<Protected><Gate need="pro"><Scorecard /></Gate></Protected>} />
            <Route path="/stock/:ticker" element={<Protected><StockDetail /></Protected>} />
            <Route path="/portfolio" element={<Protected><Trading /></Protected>} />
            <Route path="/assistant" element={<Protected><Assistant /></Protected>} />
            <Route path="/alerts" element={<Protected><Gate need="pro"><Alerts /></Gate></Protected>} />
            <Route path="/install" element={<Protected><Install /></Protected>} />
            <Route path="/pricing" element={<Protected><Pricing /></Protected>} />
            <Route path="/account" element={<Protected><Account /></Protected>} />
            <Route path="/invite" element={<Protected><Invite /></Protected>} />
            <Route path="/guide" element={<Protected><Guide /></Protected>} />
            <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
            <Route path="/payment/cancel" element={<Protected><PaymentCancel /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
